import React from "react";
import { ArrowRight, FileText, CheckCircle2 } from "lucide-react";
import { Button } from "./ui/button";
import { SPECIALIZZAZIONI, CONTACT } from "../data/mock";

export default function Formazione() {
  return (
    <section id="formazione" className="relative py-24 md:py-32 overflow-hidden">
      {/* Decorative outline number */}
      <div className="pointer-events-none absolute -top-10 right-0 hidden md:block text-[220px] outline-number font-extrabold leading-none">
        01
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 reveal">
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">_formazione</div>
            <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.08]">
              Diventa Consulente ed <span className="text-[#102a6b]">Educatore</span> del Futuro
            </h2>
            <p className="mt-5 text-slate-600 text-lg leading-relaxed">
              I nostri corsi formano nuove figure professionali in grado di operare nel mondo
              digitale, tecnologico e sostenibile. Ogni percorso include lezioni teoriche, casi
              pratici e affiancamento diretto con esperti del settore.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <a href="https://server.esserete.it/formazioneassociazioni.html" target="_blank" rel="noreferrer">
                <Button variant="outline" className="border-slate-300 text-[#102a6b] hover:bg-[#102a6b]/5 hover:text-[#102a6b] h-11">
                  <FileText className="mr-2 h-4 w-4" />
                  Documenti dell'Associazione
                </Button>
              </a>
              <a href={CONTACT.iscrizione} target="_blank" rel="noreferrer">
                <Button className="bg-[#102a6b] hover:bg-[#0a1f55] text-white h-11">
                  Iscriviti Subito
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </a>
            </div>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="relative rounded-3xl border border-slate-200 bg-white p-7 md:p-9 shadow-[0_30px_80px_-40px_rgba(16,42,107,0.25)]">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-[#f59e0b]">01 / Corso</div>
                  <h3 className="mt-2 text-xl md:text-2xl font-extrabold text-[#0a1f55] leading-tight">
                    Consulente Digitale Tecnologico e di Sostenibilità
                  </h3>
                </div>
                <div className="hidden md:flex h-12 w-12 shrink-0 rounded-xl bg-gradient-to-br from-[#102a6b] to-[#1e40af] text-white items-center justify-center">
                  <ArrowRight className="h-5 w-5" />
                </div>
              </div>

              <div className="mt-6 rounded-xl bg-[#f5f7ff] border border-slate-200/70 p-4 md:p-5">
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-[#f59e0b]/10 text-[#b45309] text-[11px] font-bold uppercase tracking-wider">In arrivo</span>
                  <span className="text-sm font-semibold text-[#0a1f55]">Specializzazioni</span>
                </div>
                <p className="mt-2 text-[14px] text-slate-600">
                  Stiamo finalizzando le prossime specializzazioni del percorso. A breve pubblicheremo
                  programma completo, date e modalità di iscrizione.
                </p>
              </div>

              <ul className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                {SPECIALIZZAZIONI.map((s, i) => (
                  <li key={s} className="flex items-start gap-2.5">
                    <CheckCircle2 className="h-4.5 w-4.5 mt-0.5 text-[#102a6b]" />
                    <span className="text-[14.5px] text-slate-700">{s}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Banner: gli altri corsi sono nell'Area Soci */}
            <a
              href="/area-soci"
              data-testid="banner-altri-corsi"
              className="mt-6 group block rounded-2xl bg-gradient-to-r from-[#0a1f55] via-[#102a6b] to-[#1e40af] p-5 md:p-6 shadow-xl hover:shadow-2xl transition-all overflow-hidden relative"
            >
              <div className="absolute -top-8 -right-8 h-32 w-32 rounded-full bg-[#f59e0b]/25 blur-2xl group-hover:bg-[#f59e0b]/35 transition-colors" />
              <div className="relative flex items-center gap-4 flex-wrap justify-between">
                <div className="flex items-center gap-4 min-w-0">
                  <div className="h-12 w-12 rounded-xl bg-[#f59e0b]/20 text-[#fbbf24] flex items-center justify-center flex-shrink-0">
                    <FileText className="h-6 w-6" />
                  </div>
                  <div className="min-w-0">
                    <div className="text-[10.5px] uppercase tracking-[0.2em] font-extrabold text-[#fbbf24]">Solo per soci</div>
                    <p className="text-white font-extrabold text-[15px] md:text-[16px] leading-snug">
                      Tutti gli altri corsi sono disponibili all&apos;interno dell&apos;Area Riservata dei Soci
                    </p>
                  </div>
                </div>
                <div className="inline-flex items-center gap-2 px-4 h-10 rounded-lg bg-[#f59e0b] text-[#0a1020] font-extrabold text-[12.5px] group-hover:bg-[#fbbf24] transition-colors">
                  Accedi all&apos;Area Soci <ArrowRight className="h-4 w-4" />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
